import { IS_DEBUG_MARKETPLACE_ENABLED } from '@/components/constants/flags';
import { atom, useAtomValue } from 'jotai';
import { getDefaultStore } from 'jotai/vanilla';

export const integrationsDebuggerEnabledAtom = atom(false);

const store = getDefaultStore();

declare global {
  interface Window {
    toggleIntegrationsDebugger: () => void;
  }
}

if (typeof window !== 'undefined') {
  window.toggleIntegrationsDebugger = () => {
    store.set(integrationsDebuggerEnabledAtom, (s) => !s);
  };
}

export const useIntegrationsDebugger = () => {
  const integrationsDebuggerEnabled = useAtomValue(integrationsDebuggerEnabledAtom);
  return {
    isIntegrationsDebuggerEnabled:
      IS_DEBUG_MARKETPLACE_ENABLED() && integrationsDebuggerEnabled,
  };
};
